import { render, staticRenderFns } from "./formGreatness.vue?vue&type=template&id=a53447e4&scoped=true&"
import script from "./formGreatness.vue?vue&type=script&lang=js&"
export * from "./formGreatness.vue?vue&type=script&lang=js&"
import style0 from "./formGreatness.vue?vue&type=style&index=0&id=a53447e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53447e4",
  null
  
)

export default component.exports